import c from 'classnames';

import { ConditionForKit } from 'types/Conditions';
import { Kit } from '@repo/types';
import { useAnalytics } from 'contexts/analytics/AnalyticsProvider';

import { Card, Markdown, TextLink } from 'components';
import { Icon } from '@repo/ui';

import { conditionEvaluationIcon } from '../conditionEvaluation';
import styles from './ConditionCard.module.css';

type ConditionCardProps = {
  condition: ConditionForKit;
  title?: string;
  kit?: Kit | null;
  withFooter?: boolean;
  withDetails?: boolean;
  withEvaluationText?: boolean;
};

export const ConditionCard = ({
  condition,
  kit,
  withFooter,
  withEvaluationText,
  withDetails,
  title,
}: ConditionCardProps) => {
  const { trackEvent } = useAnalytics();
  const evaluationIcon = conditionEvaluationIcon(condition.evaluation_meaning);
  return (
    <Card
      title={
        title ? (
          <span className={styles.title}>{condition.display_title}</span>
        ) : null
      }
    >
      <div
        className={c(
          styles.conditionEvaluation,
          styles['evaluation-' + condition.evaluation_meaning],
        )}
      >
        {evaluationIcon && <Icon name={evaluationIcon} size='m' />}
        <span>{condition.evaluation}</span>
      </div>
      {withEvaluationText && condition?.evaluation_text && (
        <div className={styles.secondaryText}>
          <Markdown>{condition.evaluation_text}</Markdown>
        </div>
      )}
      {!!kit && !withFooter && (
        <div className={styles.data}>
          <div className={styles.flexRow}>
            <Icon name='atSignFilled' size='xs' />
            <span>{`Tested at ${kit.sample_label}`}</span>
          </div>
          <div className={styles.flexRow}>
            <Icon name='markerPin02Filled' size='xs' />
            {`Checkpoints: ${condition.checkpoints}`}
          </div>
        </div>
      )}
      {!!kit && withDetails && (
        <div className={styles.details}>
          <TextLink
            label='View details'
            iconNameRight='chevronForward'
            to={`/results/${kit.id}/conditions/${condition.id}`}
            onClick={() => {
              trackEvent('Emerging Research Detail Viewed', {
                condition_name: condition.display_title ?? '',
                biomarker_name: condition.display_title ?? '',
              });
            }}
          />
        </div>
      )}
      {withFooter && condition?.checkpoints ? (
        <span className={styles.footer}>
          <Icon name='markerPin02Filled' size='xs' />
          {`Checkpoints: ${condition.checkpoints}`}
        </span>
      ) : null}
    </Card>
  );
};
